var $ = require('jquery'), scope = require('scope');

var eventMap = {
    'button': { omni:'%0%'},
    'check': { omni:'%0%'},
    'scrollPercentage': { omni:'scroll:%1%'},
    'connect': { omni:'conectar-meu-%0%', fbq: 'Lead'},
    'discover': { omni:'descubra-aqui'},
    'seeallcolors': { omni:'%0%:ver-todas-as-cores'},
    'buynow': { omni:'%0%:comprar-agora', fbq: 'Purchase'},
    'share': { omni:'%0%:compartilhar'},
    'experience': { omni:'%0%:experimente'},
};


var firstignore = true;
var duplicateFix = false;

function Metrics() {
    var self = this;
    var queues = { omni: [] };

    //Valide if is mobile
    var version = '';
    if (/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
        version = 'mobile:'
    }

    function parseVars(str, vars) {
        if (vars) {
            vars = vars + '';
            vars = vars.split(',');

            for (var x = 0; x < vars.length; x++) {
                str = str.replace('%' + x + '%', vars[x]);
            }
        }

        return str;
    }

    function varToMap(map, vars) {
        if (vars && map.key !== undefined && map.value) {
            vars = vars + '';
            vars = vars.split(',');

            if (vars[map.key]) {
                return map.value[vars[map.key]];
            }
        }

        return map;
    }

    function event(event, vars, type) {
        
        if (duplicateFix === event) return;

        duplicateFix = event;

        setTimeout(function(){
            duplicateFix = false;
        },10);

        var axel = Math.random() + "";
        var a = axel * 10000000000000;

        if(!eventMap[event]){
            console.warn(event + ', event map not exist');
            return;
        }

        if (window.s_gi) {
            if (eventMap[event] && eventMap[event].omni) {
                var s = s_gi('sssamsung4br,sssamsung4mstglobal');
                
                s.linkTrackVars = 'eVar33,events';
                s.linkTrackEvents = 'event45';
                s.events = 'event45';
                s.eVar33 = 'br:campaign:seda:'+defCampaignName+':' + parseVars(eventMap[event].omni, vars);
                s.eVar46 = '';
                s.eVar30 = '';

                s.tl(this, 'button', ''+defCampaignName+':' + parseVars(eventMap[event].omni, vars));
            }
        } else {
            queues.omni.push(event);
            return;
        }

        if (eventMap[event] && eventMap[event].fbq) {
            fbq('trackSingle', '385506452808767', eventMap[event].fbq);
        }
    }

    this.event = event;

    $(document).on('click', '[data-metrics]', function (e) {
        var ev = $(e.currentTarget).attr('data-metrics');

        if(
            e.currentTarget.tagName.toUpperCase() === 'INPUT' && 
            $(e.currentTarget).attr('type') !== 'button' &&
            $(e.currentTarget).attr('type') !== 'submit'
        ){
            return;
        }else if(
            e.currentTarget.tagName.toUpperCase() === 'TEXTAREA' ||
            e.currentTarget.tagName.toUpperCase() === 'SELECT'
        ){
            return;
        }

        if (ev) {
            event(ev, $(e.currentTarget, e).attr('data-metrics-vars'));
        }
    });

    $(document).on('change', 'input[data-metrics-change],textarea[data-metrics-change],select[data-metrics-change]', function (e) {
        var ev = $(e.currentTarget).attr('data-metrics');
        
        if (ev) {
            event(ev, $(e.currentTarget, e).attr('data-metrics-vars'), e);
        }
    });

    $(document).on('mouseenter', '[data-metrics-hover]', function (e) {
        var ev = $(e.currentTarget).data('metrics');
        if (ev) {
            event(ev, $(e.currentTarget).data('metrics-vars'));
        }
    });

    $(document).on('change', 'input[type="checkbox"][data-metrics-check],input[type="radio"][data-metrics-check]', function (e) {
        var ev = $(e.currentTarget).attr('data-metrics-check');
        
        if (ev) {
            if($(e.currentTarget).is(":checked")){
                event(ev, $(e.currentTarget, e).attr('data-metrics-check-vars'), e);
            }else{
                event(ev, $(e.currentTarget, e).attr('data-metrics-uncheck-vars'), e);
            }
        }
    });

    var preventDuplicate = [];
    var sections = $([]);

    this.initSections = function () {
        sections = $('[data-metric-scroll]');
        stopScroll = false;
    };

    var stopScroll = false;

    this.stopScroll = function () {
        stopScroll = true;
    };

    this.resumeScroll = function () {
        self.startScroll(null);
    };

    this.startScroll = function (fragment) {
        stopScroll = false;
        var section = $((fragment || window.location.hash).replace('!', ""));
        var metric = section.data('metric-scroll');
        var vars = section.data('metrics-vars');
        if (metric && !$(section).data('fired') && ($.inArray( metric + '+' + vars, preventDuplicate) == -1) ) {
            event(metric, vars);
            $(section).data('fired', true);
            preventDuplicate.push(metric + '+' + vars);
        }
    };

    this.eventScroll = function (metric, vars) {
        if (metric && ($.inArray( metric + '+' + vars, preventDuplicate) == -1) ) {
            event(metric, vars);
            preventDuplicate.push(metric + '+' + vars);
        }
    };

    var nowpage, scrollMetric = {};

    $(window).on('scroll', function (e) {
        var lastEl = null;
        var lastPos = null;
        if (!stopScroll && nowpage) {
            for (var i = 0; i < sections.length; i++) {
                var el = $(sections[i]);
                if (el.css('display') !== 'none' && (el.offset().top) - $(window).scrollTop() < 0) {
                    lastEl = el;
                    lastPos = i;
                }
            }

            var nowPercentage = ($(window).scrollTop() + $(window).height()) / $(document).height();

            if(nowPercentage){
                if (!scrollMetric[25] && nowPercentage > 0.25) {
                    scrollMetric[25] = true;
                    event('scrollPercentage', nowpage + ',25', 46);
                } else if (!scrollMetric[50] && nowPercentage > 0.50) {
                    scrollMetric[50] = true;
                    event('scrollPercentage', nowpage + ',50', 46);
                } else if (!scrollMetric[75] && nowPercentage > 0.75) {
                    scrollMetric[75] = true;
                    event('scrollPercentage', nowpage + ',75', 46);
                } else if (!scrollMetric[100] && nowPercentage > 0.99){
                    scrollMetric[100] = true;
                    event('scrollPercentage', nowpage + ',100', 46);
                }
            }

            if (lastEl) {
                var vars = lastEl.data('metrics-vars');
                var metric = lastEl.data('metric-scroll');
                if (!$(sections[lastPos]).data('fired') && ($.inArray( metric + '+' + vars, preventDuplicate) == -1)) {
                    $(sections[lastPos]).data('fired', true);
                    preventDuplicate.push(metric + '+' + vars);
                    event(metric, vars);
                }
            }
            if($(window).scrollTop() + $(window).height() == $(document).height()) {
                var lastSection = $(sections[sections.length - 1]);
                var vars = lastSection.data('metrics-vars');
                var metric = lastSection.data('metric-scroll');
                if(!lastSection.data('fired') && ($.inArray( metric + '+' + vars, preventDuplicate) == -1)) {
                    lastSection.data('fired', true);
                    preventDuplicate.push(metric + '+' + vars);
                    event(metric, vars);
                }
            }
        }
    });

    $(window).scroll();

    var ignoreduplicate;

    function pageview(page) {
        nowpage = page; 
        console.log(page);
        $(window).scroll();
        var now = page;

        if(now == ignoreduplicate){
            return;
        }

        ignoreduplicate = now;

        if (window.s_gi) {
            var s = s_gi('sssamsung4br,sssamsung4mstglobal');

            delete s.events;
            delete s.eVar33;

            s.pageName = 'br:campaign:seda:'+defCampaignName+':' + page;
            s.hier1 = 'br>campaign>seda>'+defCampaignName+'>' + page;
            s.channel = "br:campaign";
            s.prop1 = "br";
            s.prop2 = "br:campaign";
            s.prop3 = "br:campaign:seda";
            s.prop4 = 'br:campaign:seda:'+defCampaignName;
            s.prop5 = 'br:campaign:seda:'+defCampaignName+':' + page;

            var s_code = s.t();
            console.log('envia'+page);

            if (s_code) document.write(s_code);
        }

        
    }

    this.pageview = pageview;

    window.metric = event;
}


module.exports = new Metrics();



// WEBPACK FOOTER //
// ./resources/scripts/lib/metrics.js